import uniqueId from 'lodash/uniqueId';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { Carousel } from 'react-responsive-carousel';
import Image from 'components/Image';
import Video from 'components/Video';
import styles from './index.scss';

class HeroCarousel extends PureComponent {
  static propTypes = {
    playlist: PropTypes.object,
    compact: PropTypes.bool,
    relay: PropTypes.object.isRequired,
    style: PropTypes.object,
    itemClickListener: PropTypes.func,
    assetKey: PropTypes.string,
    assetTypeKey: PropTypes.string,
  };

  handleItemClick = (index, item) => {
    const { compact, itemClickListener } = this.props;
    if (!compact && item.type === 'a') {
      const el = document.getElementById(item.key);
      if (el) {
        el.click();
      }
    }
    if (itemClickListener) {
      itemClickListener(item);
    }
  };

  renderItem = (item, style, compact) => {
    if (item) {
      const { itemClickListener, assetTypeKey } = this.props;
      const getType = assetTypeKey || 'type';
      return item?.[getType] === 'Video'
        ? this.renderVideo(
            item,
            item?.assetId,
            style,
            !compact && item?.hlsPlaylistUrl,
          )
        : this.renderImage(
            item,
            item?.assetId,
            style,
            !compact && item?.hlsPlaylistUrl,
            compact && itemClickListener,
          );
    }
    return this.renderImage(null, uniqueId(), style);
  };

  renderImage = (asset, key, style, url, itemClickListener) => {
    const img = (
      <Image
        alt={asset && asset.description}
        src={asset && asset.hlsPlaylistUrl}
        style={style}
        onClick={itemClickListener}
        tabIndex={itemClickListener && 0}
        className={itemClickListener && styles.container}
      />
    );
    return url ? (
      <a
        href={url}
        id={key}
        key={key}
        target='_blank'
        rel='noopener noreferrer'
      >
        {img}
      </a>
    ) : (
      <span
        key={key}
        tabIndex={itemClickListener && -1}
        className={itemClickListener && styles.container}
      >
        {img}
      </span>
    );
  };

  renderVideo = (asset, key, style, url) => {
    let sources = [];
    if (asset?.provider && asset.basename) {
      sources = asset.basename;
    } else if (asset.hlsPlaylistUrl) {
      sources = asset.hlsPlaylistUrl;
    } else {
      if (asset.mp4Url) {
        sources.push({
          src: asset.mp4Url,
          type: 'video/mp4',
        });
      }
      if (asset.webmUrl) {
        sources.push({
          src: asset.webmUrl,
          type: 'video/webm',
        });
      }
    }
    return <Video key={key} href={url} sources={sources} style={style} />;
  };

  render() {
    const { playlist, compact, relay, style, assetKey, ...props } = this.props;
    const getAsset = assetKey || 'assets';

    return compact
      || !playlist
      || !playlist[getAsset]
      || playlist?.[getAsset]?.length === 1 ? (
      this.renderItem(playlist?.[getAsset][0], style, compact)
    ) : (
      <>
        {playlist[getAsset]?.length === 0 ? (
          <Image />
        ) : (
          <Carousel
            autoPlay={playlist.autoPlay}
            className={styles.container}
            dynamicHeight
            infiniteLoop
            interval={7000}
            onClickItem={this.handleItemClick}
            showStatus={false}
            showThumbs={false}
            stopOnHover
            style={{ cursor: 'auto' }}
            {...props}
          >
            {playlist[getAsset].map(item => this.renderItem(item, style))}
          </Carousel>
        )}
      </>
    );
  }
}

export default HeroCarousel;
